module.exports = __webpack_public_path__ + "img/jpk.8e67a024.gif";